import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormMunicipality, { MunicipalityForm } from 'system/geographic/components/municipality/form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs, validationSchemaItalian } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Municipality } from 'shell/models/municipality';
import { toast } from 'react-toastify';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import {
  transformRequestMunicipalityItalian,
  transformResponseMunicipalityEditItalian,
} from 'system/geographic/utils/transformer-municipality-edit';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const MunicipalityEditPage = (): React.ReactElement => {
  const updateMunicipality = useHttpClient(`${__MUNICIPALITY_API_URL__}/geo/comune/italiano`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
    },
  });

  const params = useParams();

  const [municipalityData] = useHttpFetch<HttpResponse<Municipality>, MunicipalityForm>(
    `${__MUNICIPALITY_API_URL__}/geo/comune/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: transformResponseMunicipalityEditItalian,
    }
  );

  const municipality = municipalityData.data as MunicipalityForm;

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: MunicipalityForm | undefined) => {
      const data = transformRequestMunicipalityItalian(formValues);
      (
        updateMunicipality({
          url: `/${formValues?.code}`,
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/comune');
      });
    },
    [updateMunicipality, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Modifica Comune Italiano' }]} />
      {municipalityData.isLoading || municipalityData.hasErrors || !municipality ? undefined : (
        <FormMunicipality
          title="Modifica Comune Italiano"
          onOk={onSubmit}
          isEdit
          validationSchema={validationSchemaItalian}
          initialValues={municipality}
          onCancel={() => {
            navigate('/sistema/geografiche/comune');
          }}
        />
      )}
    </Fragment>
  );
};

MunicipalityEditPage.displayName = 'Municipality edit page component';

export default MunicipalityEditPage;
